export default {
  create($params) {
    return Request.post('api/user', $params);
  },
  applyJob($params) {
    return Request.post('api/user/apply_job', $params);
  },
};
